import React from "react";
import styled from "styled-components";

// import { BhLogin } from "../../DivWrapperScreen/login/login";

const StyledElement = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;

& .overlay-content {
    position: relative;
    // margin: 20px auto;
    // padding: 20px;
    z-index: 1;
    display: flex;
    flex-direction: column;
}

`;


export const BhHomepage6 = () => {

    return (
        <StyledElement>
            <img className="background-image" alt="background-image" src="/image/Page6.png" />
        </StyledElement>
    );
};
